import { Component, OnInit } from '@angular/core';

@Component({
  selector:    'app-bankia-success',
  templateUrl: './bankia-success.component.html',
  styleUrls:   ['./bankia-success.component.scss']
})
export class BankiaSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
